export enum ANALYTICS_EVENTS {
    USER_CLICKS_TO_LOGIN = 'user_clicks_to_login',
    USER_SUCCESSFULLY_LOGS_IN = 'user_successfully_logs_in',
    /*create qmr events*/
    USER_CLICKS_CREATE_A_QMR = 'qmr_user_clicks_create',
    USER_CLICKS_CREATE_QMR = 'user_clicks_create_qmr',

    QMR_NQR_VIN_CHECK_SUBMITTED = 'qmr_nqr_vin_check_submitted',
    QMR_NQR_DRAFT_CREATED = 'qmr_nqr_draft_created',
    QMR_NQR_SUBMISSION_STARTED = 'qmr_nqr_submission_started',
    QMR_NQR_SUBMISSION_SUCCEEDED = 'qmr_nqr_submission_succeeded',
    QMR_NQR_VALIDATION_FAILED = 'qmr_nqr_validation_failed',
    QMR_NQR_VALIDATION_PASSED = 'qmr_nqr_validation_passed',
    QMR_NQR_FORM_OPENED = 'qmr_nqr_form_opened',
    QMR_NQR_CREATE_INITIATED = 'qmr_nqr_create_initiated',
    QMR_NQR_SUBMISSION_FAILED = 'qmr_nqr_submission_failed',
    QMR_NQR_FAIL_CODE_SELECTED = 'qmr_nqr_fail_code_selected',
    QMR_CONVERTED_TO_NQR = 'qmr_converted_to_nqr',
    NQR_CONVERTED_TO_QMR = 'nqr_converted_to_qmr',
    USER_GIVES_FEEDBACK = 'user_gives_feedback',
    USER_CHANGES_QMR_STATUS = 'user_changes_qmr_status',
    USER_REPLIES_TO_FEEDBACK = 'user_replies_to_feedback',
    USER_REQUESTS_FEEDBACK = 'user_requests_feedback',
    USER_CHANGED_SCREENS = 'user_changed_screens',
    USER_CHANGED_PAGE = 'user_changed_page',
    USER_OPENS_FAILCODE_MODAL = 'user_opens_failcode_modal',
    USER_CLOSES_FAILCODE_MODAL = 'user_closes_failcode_modal',
    USER_SUCCESSFULLY_ADDS_FAILCODE = 'user_successfully_adds_failcode',
    USER_STARTS_ATTACHMENT = 'user_starts_attachment',
    USER_STARTS_ADVANCED_SEARCH = 'user_starts_advanced_search',
    USER_SAVES_ADVANCED_SEARCH = 'user_saves_advanced_search',
    ADVANCED_SEARCH_LOADED = 'advanced_search_loaded',
    USER_SEARCHES_BY_QUICKSEARCH = 'user_searches_by_quicksearch',
    USER_SEARCHES_BY_TEXT = 'user_searches_by_text',
    USER_CLICKS_CREATE_INFOTAINMENT_CASE = 'user_clicks_create_infotainment_case',
    USER_CLICKS_VIEW_OPEN_INFOTAINMENT_CASE = 'user_clicks_view_open_infotainment_case',
    USER_CLICKS_CLOSE_INFOTAINMENT_CASE = 'user_clicks_close_infotainment_case',

    USER_CLICKS_CREATE_A_TECHLINE_CASE = 'user_clicks_create_a_techline_case',
    USER_SELECTS_RETAILER = 'user_selects_retailer',
    USER_SELECTS_PRIMARY_OBJECTIVES = 'user_selects_primary_objectives',
    USER_SELECTS_VEHICLE = 'user_selects_vehicle',
    USER_SELECTS_CARLINE = 'user_selects_carline',
    USER_OPENS_EXISTING_CASE = 'user_opens_existing_case',

    USER_CREATES_DRAFT_TECHLINE_CASE = 'user_creates_draft_techline_case',
    USER_CLICKS_SUBMIT_TECHLINE_CASE = 'user_clicks_submit_techline_case',
    TECHLINE_CASE_FORM_STARTED = 'techline_case_form_started',
    TECHLINE_VALIDATION_FAILED = 'techline_validation_failed',
    TECHLINE_REQUIRED_FIELDS_COMPLETED = 'techline_required_fields_completed',
    TECHLINE_COMPLETE_WORKSHEET_CLICKED = 'techline_complete_worksheet_clicked',
    TECHLINE_EDIT_WORKSHEET_CLICKED = 'techline_edit_worksheet_clicked',
    TECHLINE_SAVE_WORKSHEET_CLICKED = 'techline_save_worksheet_clicked',
    TECHLINE_DELETE_WORKSHEET_CLICKED = 'techline_delete_worksheet_clicked',
    TECHLINE_SAVE_WORKSHEET_SAVED = 'techline_save_worksheet_saved',
    TECHLINE_CASE_SAVE_STARTED = 'techline_case_save_started',
    TECHLINE_CASE_SAVE_SUCCESS = 'techline_case_save_success',
    TECHLINE_CASE_SAVE_FAILED = 'techline_case_save_failed',

    USER_SUCCESSFULLY_SUBMITS_TECHLINE_CASE = 'user_successfully_submits_techline_case',
    USER_ADDS_DTC = 'user_adds_dtc',
    USER_STARTS_ADDING_FAILCODE = 'user_starts_adding_failcode',
    USER_ADDS_WORKSHEET = 'user_adds_worksheet',
    USER_DELETES_WORKSHEET_DRAFT = 'user_deletes_worksheet_draft',
    USER_SUBMITS_WORKSHEET = 'user_submits_worksheet',
    USER_VIEWS_WORKSHEET = 'user_views_worksheet',
    USER_STARTS_ATTACHMENT_FLOW = 'user_starts_attachment_flow',
    USER_SUCCESSFULLY_UPLOADS_ATTACHMENT = 'user_successfully_uploads_attachment',
    USER_SEARCHES_TECHLINE_CASES = 'user_searches_techline_cases',
    USER_ADDS_COMMENT = 'user_adds_comment',
    USER_STARTS_ATTACHMENT_COMMENT = 'user_starts_attachment_comment',
    USER_SUCCESSFULLY_UPLOADS_ATTACHMENT_COMMENT = 'user_successfully_uploads_attachment_comment',
    USER_STARTS_CLOSE_CASE_FLOW = 'user_starts_close_case_flow',
    USER_SUCCESSFULLY_CLOSES_TECHLINE_CASE = 'user_successfully_closes_techline_case',
    USER_DELETES_TECHLINE_DRAFT = 'user_deletes_techline_draft',
    USER_CLICKS_NOTIFICATION_LINK = 'user_clicks_notification_link',
    USER_CLICKS_TO_LOGOFF = 'user_clicks_to_logoff',
    USER_SUCCESSFULLY_LOGS_OFF = 'user_successfully_logs_off',

    MEDIA_UPLOADED = 'media_uploaded',
    TECHLINE_CASE_CREATED = 'techline_case_created',

    /*vin session events*/
    VIN_SESSION_CLICKED = 'vin_session_clicked',
    VIN_SESSION_OPENED = 'vin_session_opened',
    VIN_SESSION_VEHICLE_CARD_CLICKED = 'vin_session_vehicle_card_clicked',
    VIN_SESSION_VEHICLE_CARD_VIEWED = 'vin_session_vehicle_card_viewed',
    VIN_SESSION_CLOSED = 'vin_session_closed',
    VIN_SESSION_ENGAGEMENT_SUMMARY = 'vin_session_engagement_summary',
    VIN_SESSION_MODULE_OPENED = 'vin_session_module_opened',
    /*vin session events ends*/

    BIOMETRIC_LOGIN_SUCCESS = 'biometric_login_success',
    BIOMETRIC_LOGIN_FAILURE = 'biometric_login_failure',
    BIOMETRIC_LOGIN_INACTIVE_USER = 'biometric_login_inactive_user',
    BIOMETRIC_LOGIN_TOKEN_EXPIRED = 'biometric_login_token_expired',
    QMR_SEARCH_USED = 'qmr_search_used',

    QMRDASH_USER_VISITED_DSQM_DASHBOARD = 'qmrdash_user_visited_dsqm_dashboard',
    QMRDASH_USER_CHANGED_PERIOD = 'qmrdash_user_changed_period',
    QMRDASH_USER_CHANGED_PERIOD_COMPARED_TO = 'qmrdash_user_changed_period_compared_to',
    QMRDASH_USER_CLICKED_HAVE_YOU_SEEN = 'qmrdash_user_clicked_have_you_seen',
    QMRDASH_USER_CLICKED_HELPFUL_LINK = 'qmrdash_user_clicked_helpful_link',
    QMRDASH_USER_CLICKED_COUNTER_MEASURES_OF_THE_MONTH = 'qmrdash_user_clicked_counter_measures_of_the_month',
    QMRDASH_USER_CLICKED_TO_REVIEW_QMR = 'qmrdash_user_clicked_to_review_qmr',
    QMRDASH_USER_CLICKED_PENDING_QMR = 'qmrdash_user_clicked_pending_qmr',

    USER_CLICKS_ON_TECHLINE_VIN_SCAN = 'user_clicks_on_techline_vin_scan',
    USER_CLICKS_ON_QMR_VIN_SCAN = 'user_clicks_on_qmr_vin_scan',
    VIN_SCAN_SUCCESSFUL = 'vin_scan_successful',
    VIN_SCAN_FAILD = 'vin_scan_faild',
    USER_ENTERED_VIN_TECHLINE = 'user_entered_vin_techline',
    USER_ENTERED_VIN_QMR = 'user_entered_vin_qmr',
    EVD_START_CLICKED = 'evd_start_clicked',
    WEB_SCAN_ATTEMPT = 'web_scan_attempt',
    WEB_PARSE_SUCCESS = 'web_parse_success',
    WEB_PARSE_FAIL = 'web_parse_fail',
    WEB_SUBMIT_ATTEMPT = 'web_submit_attempt',
    WEB_SUBMIT_SUCCESS = 'web_submit_success',
    WEB_SUBMIT_FAIL = 'web_submit_fail',
    FUNCTIONAL_JOURNEY_STARTED = 'functional_journey_started',
    FUNCTIONAL_JOURNEY_ENDED = 'functional_journey_ended',
    PAGE_VIEW = 'page_view',

    /* stis events */
    STIS_OPENED = 'stis_opened',
    STIS_SEARCH_PERFORMED = 'stis_search_performed',
    STIS_SEARCH_SUCCESS = 'stis_search_success',
    STIS_SEARCH_FAILED = 'stis_search_failed',
    STIS_SEARCH_NO_RESULTS = 'stis_search_no_results',
    STIS_RESULT_CLICKED = 'stis_result_clicked',
    STIS_DOCUMENT_PREVIEWED = 'stis_document_previewed',
    STIS_DOCUMENT_DOWNLOADED = 'stis_document_downloaded',
    STIS_DOCUMENT_OPENED = 'stis_document_opened',
    STIS_DOCUMENT_OPEN_FAILED = 'stis_document_open_failed',
    STIS_FILTER_APPLIED = 'stis_filter_applied',
    STIS_DOCUMENT_SHARED = 'stis_document_shared',
    STIS_DOCUMENT_FAVORITED = 'stis_document_favorited',
    STIS_DOCUMENT_REMOVED_FROM_RECENTS = 'stis_document_removed_from_recents',

    /*cid-cvn events */
    CID_CVN_CHECK_INITIATED = 'cid_cvn_check_initiated',
    CID_CVN_CHECK_SUBMITTED = 'cid_cvn_check_submitted',
    CID_CVN_RESULT_RECEIVED = 'cid_cvn_result_received',
    CID_CVN_RESULT_VIEWED = 'cid_cvn_result_viewed',
    CID_CVN_RETRY_SUBMITTED = 'cid_cvn_retry_submitted',
    CID_CVN_TECHLINE_CASE_STARTED = 'cid_cvn_techline_case_started',

    /* cvt module events */
    CVT_TOOL_ACCESSED = 'cvt_tool_accessed',
    CVT_FILE_UPLOAD_STARTED = 'cvt_file_upload_started',
    CVT_UPLOAD_SUCCEEDED = 'cvt_upload_succeeded',
    CVT_UPLOAD_FAILED = 'cvt_upload_failed',
    CVT_DIAGNOSTIC_SUBMITTED = 'cvt_diagnostic_submitted',
    CVT_RESULT_RECEIVED = 'cvt_result_received',
    CVT_RESULT_VIEWED = 'cvt_result_viewed',
    CVT_RETRY_SUBMITTED = 'cvt_retry_submitted',
}

export const ANALYTICS_USER_ROLES = new Set<string>([
    'LAG Super Admin',
    'SOA Super User',
    'QA Admin',
    'NASI SIA Admin',
    'Corporate User',
    'DSQM',
    'RSQM',
    'Retailer Admin',
    'Retailer User',
    'Techline Admin',
    'Techline Rep',
]);

export const ANALYTICS_ROLE_ID_MAP: Record<string, string> = {
    LAG_SUPER_ADMIN: 'LAG Super Admin',
    SOA_SUPER_USER: 'SOA Super User',
    QA_ADMIN: 'QA Admin',
    NASI_SIA_ADMIN: 'NASI SIA Admin',
    CORPORATE_USER: 'Corporate User',
    DSQM: 'DSQM',
    RSQM: 'RSQM',
    RETAILER_ADMIN: 'Retailer Admin',
    RETAILER_USER: 'Retailer User',
    TECHLINE_ADMIN: 'Techline Admin',
    TECHLINE_REP: 'Techline Rep',
};

export const ANALYTICS_ROLE_SYNONYMS: Record<string, string> = {
    'district service quality manager': 'DSQM',
    'regional service quality manager': 'RSQM',
    'techline representative': 'Techline Rep',
    'techline rep': 'Techline Rep',
};

export const ANALYTICS_UNKNOWN_ROLE = 'Unknown';

export type AnalyticsEventPrimitive = string | number | boolean | null;

export interface AnalyticsEventData {
    [key: string]: boolean | number | string | Record<string, AnalyticsEventPrimitive> | undefined;
    user_role?: string;
    role?: string;
    userId?: string;
    journey_id?: string;
    params?: Record<string, AnalyticsEventPrimitive>;
}
